module.exports = __webpack_public_path__ + "img/1479428023.96021a61.jpg";